import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Component } from 'react';

import FormInput, { FormInputProps } from '../../../../shared/components/FormInput';
import { withIdPrefix } from './withIdPrefix';

type CityProps = FormInputProps;

@observer
class City extends Component<CityProps> {
  render() {
    const { className, label, inputClassName, ...otherProps } = this.props;

    return (
      <FormInput
        label={label || 'City'}
        className={className}
        inputClassName={classNames(inputClassName)}
        {...otherProps}
      />
    );
  }
}

export default withIdPrefix(City, 'city');
